// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list{display:inline-block;width:100%;margin-bottom:1.5rem}.list:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
